import type { VariantProps } from 'class-variance-authority';

import * as React from 'react';

import { cn } from '@elara/client-core/lib/utils';

import { badgeVariants } from './badge-variants.js';

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant, size }), className)} {...props} />;
}

export { Badge };
